export interface IUser {
  firstName: string
  lastName: string
  language: string
  email: string
  phone: string
  orgName: string
  roleName: string
  roleDtoList: Role[]
  createdDateTime: string
  country: string
}

export enum EnumUserStatus {
  ACTIVE = 'ACTIVE',
  INVITED = 'INVITED',
  DEACTIVATED = 'DEACTIVATED',
}

export const UserStatusColor = {
  [EnumUserStatus.ACTIVE]: 'olive',
  [EnumUserStatus.DEACTIVATED]: 'orange',
  [EnumUserStatus.INVITED]: 'violet',
};

export enum RoleType {
  CLIENT_ROLE = 'CLIENT_ROLE',
  REALM_ROLE = 'REALM_ROLE',
}

export interface IOrgUser extends IUser {
  id: string
  orgId: string
  isDihUser: boolean
  firstLogin: boolean
  userStatusInOrg?: EnumUserStatus
  hasKeycloakConflict: boolean
}

export interface Role {
  id: number
  roleDescription: string
  roleName: string
  roleType: RoleType
  status: boolean
  tooltipText: string
  createDateTime: string
  updateDateTime: string
}

export interface TechnicalUser {
  id: string;
  clientId: string;
  orgId: string;
  keycloakClientUuid: string;
  serviceAccountUserId: string;
  serviceAccountRoles: string[];
  allowedUrls: string[];
  enabled: boolean;
  clientSecret: string | null;
  createDateTime: string;
  updateDateTime: string;
}

export interface TechnicalUsersResponse {
  content: TechnicalUser[];
  totalElements: number;
}

export interface RoleUpdatePayload {
  email: string
  rolesToAdd: number[]
  rolesToRemove: number[]
}

export enum SupportedLocale {
  EN = 'en',
  DE = 'de',
  ES = 'es',
  FR = 'fr',
  ZH_CN = 'zh_cn',
  JA = 'ja'
}

export const LocaleLabels: Record<SupportedLocale, string> = {
  [SupportedLocale.EN]: 'English',
  [SupportedLocale.DE]: 'German (Deutsch)',
  [SupportedLocale.ES]: 'Spanish (Español)',
  [SupportedLocale.FR]: 'French (Français)',
  [SupportedLocale.ZH_CN]: 'Chinese (中文/简体)',
  [SupportedLocale.JA]: 'Japanese (日本語)'
};
